import { LABEL_ID_RANDOM_BYTES, labelIdFromBytes } from '../../../../libs/batchTracking/labelId';

/** A label code in the handheld's format, for a batch recorded by hand. */
export const newLabelId = (): string => labelIdFromBytes(crypto.getRandomValues(new Uint8Array(LABEL_ID_RANDOM_BYTES)));
